import {
  LayoutDashboard, UserCircle, Bell, Megaphone,
  HeadphonesIcon, Mail, FileText, HelpCircle, RotateCcw,
  LayoutGrid, Receipt, ShoppingBag, ShoppingCart, Layers, Contact, Video, Newspaper
} from 'lucide-react'

export const NAV_GROUPS = [
  {
    label: 'Main',
    items: [
      { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
      { path: '/admin-profile', label: 'Admin Profile', icon: UserCircle },
    ],
  },
  {
    label: 'User Management',
    items: [
      { path: '/customer', label: 'Customer', icon: Contact },
    ],
  },
  {
    label: 'Business Management',
    items: [
      { path: '/category', label: 'Categories', icon: Layers },
      { path: '/product', label: 'Products', icon: ShoppingBag },
      { path: '/order', label: 'Orders', icon: ShoppingCart },
      // { path: '/item-management', label: 'Item Management', icon: Package },
      { path: '/transaction', label: 'Transactions', icon: Receipt },
      { path: '/invoice', label: 'Invoices', icon: FileText },

    ],
  },
  {
    label: 'Communication',
    items: [
      { path: '/push-notification', label: 'Notifications', icon: Bell },
      { label: 'Collections', path: '/collections', icon: LayoutGrid },
      { label: 'Promo Banner', path: '/promo-banner', icon: Megaphone },
      { label: 'Watch & Buy', path: '/watch-buy', icon: Video },
       { label: 'Featured In', path: '/featured-in', icon: Newspaper },
    ],
  },
  {
    label: 'Support & Policies',
    items: [
      { path: '/support', label: 'Support', icon: HeadphonesIcon },
      { path: '/return-policy', label: 'Return Policy', icon: RotateCcw },
      { path: '/contact', label: 'Contact Us', icon: Mail },
    ],
  },
  {
    label: 'System',
    items: [
      { path: '/faqs', label: 'FAQs', icon: HelpCircle },
    ],
  },
]

export const ROUTE_META = NAV_GROUPS.reduce((acc, group) => {
  group.items.forEach((item) => {
    acc[item.path] = { title: item.label, parent: group.label }
  })
  return acc
}, {})